import React from "react";

//routing
import {BrowserRouter} from "react-router-dom";
import routes from "./js/routes";

//config
import {config} from "./js/config";

//context providers
import {ContactProvider} from "./js/contexts/Contact";
import {MenuProvider} from "./js/contexts/Menu";
import {PageProvider} from "./js/contexts/Page";
import {PortfolioProvider} from "./js/contexts/Portfolio";
import {SettingsProvider} from "./js/contexts/Settings";
import {TextsProvider} from "./js/contexts/Texts";
import {PlayerProvider} from "./js/contexts/Player";


import "./App.scss";

function App() {
	return (
		<div className="App">
			<SettingsProvider>
				<TextsProvider>
					<MenuProvider>
						<PageProvider>
							<ContactProvider>
								<PortfolioProvider>
									<PlayerProvider>
										<BrowserRouter basename={config.domainRelPath}>
											{routes}
										</BrowserRouter>
									</PlayerProvider>
								</PortfolioProvider>
							</ContactProvider>
						</PageProvider>
					</MenuProvider>
				</TextsProvider>
			</SettingsProvider>
		</div>
	);
}

export default App;
